<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <strong>ShopO Similar Products</strong>
          </div>

          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="description">Product description</label>
                <b-form-input
                  v-model="description"
                  type="text"
                  id="description"
                  placeholder="E.g.: Men's red t-shirt description..."
                ></b-form-input>
              </b-form-group>
              <b-button type="submit" size="sm" variant="primary" v-on:click="findSimilar">
                <i class="fa fa-search"></i> Find similar
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <kendo-datasource
            ref="grid-datasource"
            :transport="transport"
            :schema="schema"
            :serverPaging="true"
            :serverSorting="true"
            :page-size="10"
          ></kendo-datasource>
          <kendo-grid
            :data-source-ref="'grid-datasource'"
            ref="grid"
            :selectable="'row'"
            :filterable="false"
            :groupable="false"
            :pageable="pageable"
            :pageable-always-visible="true"
            :auto-bind="true"
          >
            <kendo-grid-column :field="'Description'" :width="180"></kendo-grid-column>
            <kendo-grid-column :field="'Image'" :width="180" :template="imageTemplate"></kendo-grid-column>
          </kendo-grid>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <small class="text-muted text-uppercase font-weight-bold">
            API reference can be found
            <a :href="apiUrl+'../api-docs'">HERE</a> and
            <a :href="apiUrl+'../reference'">HERE</a>
          </small>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>

import Vue from "vue"

import "@progress/kendo-ui";
import "@progress/kendo-theme-default/dist/all.css";
import { Grid, GridInstaller } from "@progress/kendo-grid-vue-wrapper";
import { DataSource, DataSourceInstaller } from '@progress/kendo-datasource-vue-wrapper'


Vue.use(GridInstaller);
Vue.use(DataSourceInstaller)


export default {
  data: function () {
    var self = this;
    return {
      description: '',
      apiUrl: process.env.VUE_APP_API_URL,
      filter: [],
      pageable: {
        refresh: false,
        pageSizes: [5, 10, 50],
        messages: {
          display: "{0}-{1} of {2} products",
          itemsPerPage: "products per page"
        }
      },
      schema: {
        data: function (data) {
          if (self.$data.filter.length == 0)
            return data;
          else {
            var result = [];
            self.$data.filter.forEach(element => {
              result.push(data.find(el => el.id == element));
            });
            return result;
          }
        },
        model: {
          id: "id",
          fields: {
            // id: { from: "id" },
            Description: { from: "title" },
            Image: { from: "imageUrl" },
            // index: { from: "index" },
          }
        },
        total: function (data) {
          return data.total;
        }
      },
      transport: {
        read: async (options) => {
          try {
            let response = await Vue.axios.post(process.env.VUE_APP_API_URL + `shopo/list-products?take=${options.data.take}&skip=${options.data.skip}`, { ids: self.$data.filter });
            options.success(response.data);
          }
          catch (error) {
            debugger
            console.log(error)
            console.log(error.statusText);
            options.error(error.statusText);
          }
        }
      },
      //   sort: {
      //     field: "index",
      //     dir: "desc"
      //   }
    }
  },
  methods: {
    imageTemplate(e) {
      return "<img src='" + e.Image + "' width=100></img>";
    },
    findSimilar: async function () {
      try {
        let response = await Vue.axios.post(process.env.VUE_APP_API_URL + `shopo/fuzzy-search`, {
          productTitle: this.$data.description,
          numOfProducts: 10
        });
        this.$data.filter = response.data.searchResult;
        this.$refs.grid.kendoWidget().dataSource.read();
        console.log(response)
      }
      catch (error) {
        debugger
        console.log(error.statusText);
      }
    }
  }
}

</script>